import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './Input.module.css';
import dropdownicon from '../../../assets/Imagess/dropdownicon.svg';
import CheckBox from './CheckBox';
import { toast } from 'react-toastify';
import Spinner from '../../Moecules/Loader/Spinner';
import clearIcon from '../../../assets/Imagess/blackX.svg';

const CustomizedSelectwithCheckbox = ({
  options,
  onChange,
  value,
  name,
  placeholder,
  icon,
  label,
  errors,
  touched,
  required,
  height,
  minHeight,
  disabled,
  none,
  isLoading,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [selectedValues, setSelectedValues] = useState(value || []);
  const selectRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleOpenDropDowOptions = () => {
    if (disabled) {
      setIsOpen(false);
      if (!none) {
        toast.warning('Please choose a field before');
      }
    } else {
      setIsOpen(!isOpen);
    }
  };

  const handleToggleMenu = (e) => {
    if (options && !options?.length) {
      return false;
    }
    e.stopPropagation();
    setIsOpen(!isOpen);
    document.body.style.overflow = !isOpen ? 'hidden' : '';
  };

  const handleCheckboxClick = (e, option) => {
    setChecked(
      selectedValues?.some(
        (selectedOption) => selectedOption.value === option.value,
      ),
    );
    e.stopPropagation();
  };

  const toggleCheckUser = (option) => {
    let updatedValues;
    if (option.value === 'all') {
      // Handle "All" option
      if (selectedValues?.length === options?.length) {
        updatedValues = []; // Uncheck all
      } else {
        updatedValues = [...options]; // Select all
      }
    } else {
      // Handle individual option
      updatedValues = selectedValues.some(
        (selectedOption) => selectedOption.value === option.value,
      )
        ? selectedValues.filter(
            (selectedOption) => selectedOption.value !== option.value,
          )
        : [...selectedValues, option];
    }

    setSelectedValues(updatedValues);
    if (name) {
      onChange(name, updatedValues);
    } else {
      onChange(updatedValues);
    }
  };

  const handleClearSelection = () => {
    setSelectedValues([]);
    if (name) {
      onChange(name, []);
    } else {
      onChange([]);
    }
  };

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (selectRef.current && !selectRef.current?.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  useEffect(() => {
    if (options) {
      if (typeof value === 'string' && value?.length > 0) {
        const selected = value?.split(',').map((val) => {
          const option = options?.find(
            (opt) => opt.value === val.trim().replace(/'/g, ''),
          );
          return {
            value: option ? option.value : val.trim().replace(/'/g, ''),
            text: option ? option.text : val.trim().replace(/'/g, ''),
          };
        });
        setSelectedValues(selected);
      }
    }
  }, [value, options]);

  useEffect(() => {
    if (typeof value === 'string' && value !== undefined) {
      setSelectedValues([]);
    }
  }, [value]);

  const renderDropdown = () => (
    <>
      <div className={`${styles.backdrop}`} onClick={handleToggleMenu}></div>
      <div
        className={styles.dropdown}
        style={{
          position: 'absolute',
          top: dropdownRef.current?.getBoundingClientRect().bottom || 0,
          left: dropdownRef.current?.getBoundingClientRect().left || 0,
          width: dropdownRef.current?.offsetWidth || 'auto',
        }}
      >
        {/* Add "All" option */}
        <div className={styles.dropdownItem}>
          <div
            className={styles.dropdowncontainer}
            onClick={(e) =>
              handleCheckboxClick(e, { value: 'all', text: 'All' })
            }
          >
            <CheckBox
              value={selectedValues?.length === options?.length}
              onChange={() => toggleCheckUser({ value: 'all', text: 'All' })}
            />
            All
          </div>
        </div>

        {options && options?.length > 0 ? (
          options.map((option, index) => (
            <div
              key={index}
              className={
                index % 2 === 0 ? styles.dropdownItem : styles.dropdownItemOdd
              }
            >
              <div
                className={styles.dropdowncontainer}
                onClick={(e) => handleCheckboxClick(e, option)}
              >
                <CheckBox
                  value={selectedValues
                    ?.map((item) => item.value)
                    .includes(option.value)}
                  onChange={() => toggleCheckUser(option)}
                />
                {option.text}
              </div>
            </div>
          ))
        ) : (
          <div className={styles.noData}>No available data</div>
        )}
      </div>
    </>
  );

  return (
    <div className={styles.selectContainer}>
      {label ? (
        <label style={{ color: '#1B224C', opacity: disabled ? '0.5' : '1' }}>
          {label} {required && <span className={styles.required}>*</span>}
        </label>
      ) : (
        ''
      )}
      {isLoading ? (
        <Spinner />
      ) : (
        <div
          ref={(el) => {
            selectRef.current = el;
            dropdownRef.current = el;
          }}
          className={`${
            errors && touched ? styles.error : styles.selectInput
          } ${isOpen ? styles.open : ''}`}
          onClick={handleOpenDropDowOptions}
          style={{
            height: height ? height : minHeight ? 'auto' : '',
            minHeight: minHeight ? minHeight : '',
          }}
        >
          {Array.isArray(selectedValues) && selectedValues?.length > 0 ? (
            <div className={styles.selectedValueicont}>
              {' '}
              <span
                className={styles.selectedValues}
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {selectedValues &&
                  selectedValues?.length > 0 &&
                  selectedValues?.map((item) => item.text).join(', ')}
              </span>
              {!disabled && (
                <img
                  src={clearIcon}
                  alt='clear'
                  className={styles.clearIcon}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClearSelection();
                  }}
                />
              )}
            </div>
          ) : (
            <div className={styles.selectedValueicont}>
              <span className={styles.placeholder}>
                {icon && <img src={icon} alt='icon' />}
                {placeholder}
              </span>
              {!disabled && selectedValues?.length === 0 && (
                <img
                  src={dropdownicon}
                  alt='dropdown icon'
                  className={styles.arrowIcon}
                />
              )}
            </div>
          )}
        </div>
      )}
      {isOpen && ReactDOM.createPortal(renderDropdown(), document.body)}
    </div>
  );
};

export default CustomizedSelectwithCheckbox;
